interface GetInitialUser {
  docType: string,
  docId: string,
  birthdate?: string,
  healthInsurance?: string,
}

export const validatedUpdatePhone = (value: string | undefined) => {
  if (value === undefined) {
    return false
  }
  const phoneRegex = /^\d{9}$/;
  return phoneRegex.test(value);
};

export const validatedUpdateEmail = (value: string | undefined) => {
  if (value === undefined) {
    return false
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(value);
};
export const formatDocId = (values: GetInitialUser) => {
  if (values.docType === "rut") {
    let rutNumber = values.docId.replace(/\./g, '').replace(/-/g, '');
    const rutStr = rutNumber.toString();
    const body = rutStr.slice(0, -1);
    const verifier = rutStr.slice(-1);
    const formattedRUT = `${body}-${verifier}`;
    return formattedRUT;
  } else {
    return values.docId
  }
}
